<template>
    <button :class="'hover:bg-' + hoverBackground"
            class="inline-flex items-center w-full px-24 py-12 text-primary-80 text-left group trans-ease"
            @click="$emit('click')"
    >
        <svg-icon :class="'group-hover:text-' + hoverIconColor" :type="icon"
                  class="mr-16 -ml-2 w-18 aspect-square text-primary-80"></svg-icon>
        <span :class="'group-hover:text-' + hoverTextColor" class="trans-ease first-letter:uppercase">
            <slot></slot>
        </span>
    </button>
</template>

<script>
import SvgIcon from './SvgIcon.vue';

export default {
    components: {
        'svg-icon': SvgIcon,
    },
    props: {
        hoverBackground: {
            type: String,
            default: 'gray-100',
            required: false,
        },
        hoverIconColor: {
            type: String,
            default: 'gray-800',
            required: false,
        },
        hoverTextColor: {
            type: String,
            default: 'gray-900',
            required: false,
        },
        icon: {
            type: String,
            required: true,
        },
    },
};
</script>
